module.exports = __webpack_public_path__ + "img/img_caution.e8d8097c.png";